"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuSection = _interopRequireDefault(require("./components/MenuSection"));

var _MenuNavigation = _interopRequireDefault(require("./components/MenuNavigation"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Menu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Menu, _React$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    (0, _classCallCheck2["default"])(this, Menu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Menu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centerHeaders = _this$props.centerHeaders,
          imageSize = _this$props.imageSize,
          menuItems = _this$props.menuItems,
          itemsPerRow = _this$props.itemsPerRow,
          itemAs = _this$props.itemAs,
          displayCategoriesAs = _this$props.displayCategoriesAs,
          sectionAsAccordion = _this$props.sectionAsAccordion,
          showMenuNavigation = _this$props.showMenuNavigation,
          menuNavigationDivided = _this$props.menuNavigationDivided;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_MenuNavigation["default"], {
        categories: menuItems.map(function (_ref) {
          var categoryTitle = _ref.categoryTitle;
          return categoryTitle;
        }),
        displayCategoriesAs: displayCategoriesAs,
        showMenuNavigation: showMenuNavigation,
        menuNavigationDivided: menuNavigationDivided
      }), menuItems.map(function (_ref2) {
        var categoryTitle = _ref2.categoryTitle,
            categoryDescription = _ref2.categoryDescription,
            categoryItems = _ref2.categoryItems;
        return /*#__PURE__*/_react["default"].createElement(_MenuSection["default"], {
          key: categoryTitle,
          asAccordion: sectionAsAccordion,
          centerHeaders: centerHeaders,
          imageSize: imageSize,
          itemAs: itemAs,
          itemsPerRow: itemsPerRow,
          sectionTitle: categoryTitle,
          sectionDescription: categoryDescription,
          sectionItems: categoryItems
        });
      }));
    }
  }]);
  return Menu;
}(_react["default"].Component);

exports["default"] = Menu;
Menu.propTypes = {
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    categoryTitle: _propTypes["default"].string,
    categoryDescription: _propTypes["default"].string,
    categoryItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      itemThumbnail: _propTypes["default"].string,
      itemPrice: _propTypes["default"].string,
      itemTitle: _propTypes["default"].string.isRequired,
      itemDescription: _propTypes["default"].string,
      itemNote: _propTypes["default"].string,
      itemLabels: _propTypes["default"].arrayOf(_propTypes["default"].string),
      labelAsImage: _propTypes["default"].bool,
      itemCTALink: _propTypes["default"].string
    }))
  })).isRequired,
  centerHeaders: _propTypes["default"].bool,
  displayCategoriesAs: _propTypes["default"].oneOf(['button', 'text', 'header']),
  sectionAsAccordion: _propTypes["default"].bool,
  itemAs: _propTypes["default"].oneOf(['Item', 'Card']),
  imageSize: _propTypes["default"].string,
  itemsPerRow: _propTypes["default"].number,
  menuNavigationDivided: _propTypes["default"].bool,
  showMenuNavigation: _propTypes["default"].bool
};
Menu.defaultProps = {
  centerHeaders: true,
  displayCategoriesAs: 'button',
  sectionAsAccordion: false,
  itemAs: 'Item',
  imageSize: 'small',
  itemsPerRow: 2,
  menuNavigationDivided: false,
  showMenuNavigation: true
};
Menu.propOptions = {};
Menu.dataPropsMap = {};